import { Provider } from 'react-redux';
import { Context, PropsWithChildren } from 'react';

import { ApiProvider } from './ApiConsumer';
import { StateContext, ApiContext } from './contexts';
import { App as AppType } from './types';

const App = ({
  children,
  app,
  contexts = { state: StateContext, api: ApiContext },
}: PropsWithChildren<{
  app: Nullable<AppType<any, any>>;
  contexts?: { state: Context<any>; api: Context<any> };
}>) =>
  app ? (
    <Provider store={app.store} context={contexts.state}>
      <ApiProvider value={app.api} context={contexts.api}>
        {children}
      </ApiProvider>
    </Provider>
  ) : null;

export default App;
